"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var l10n_1 = require("@paprika/l10n");
var spinner_1 = __importDefault(require("@paprika/spinner"));
var Tree = function (_a) {
    var items = _a.items, expanded = _a.expanded, searchIds = _a.searchIds, renderLabel = _a.renderLabel;
    var renderChildren = function (isExpanded, item) {
        if (!isExpanded) {
            return null;
        }
        if (item.loading) {
            var i18n = l10n_1.useI18n();
            return react_1.default.createElement(spinner_1.default, { size: "small", a11yText: i18n.t('left_navigation.loading') });
        }
        return renderItems(item.childItems, item.type);
    };
    var renderItems = function (itemsToRender, parentType) {
        if (itemsToRender === undefined) {
            return null;
        }
        return itemsToRender.map(function (item) {
            if (searchIds && (!searchIds[item.type] || !searchIds[item.type].includes(item.id))) {
                return null;
            }
            var isExpanded = false;
            if (expanded[item.type]) {
                isExpanded = expanded[item.type].includes(item.id);
            }
            return (react_1.default.createElement("li", { className: "tree__node", key: item.type + "_" + item.id },
                renderLabel(item, isExpanded, parentType),
                react_1.default.createElement("ul", { className: "tree__subtree" }, renderChildren(isExpanded, item))));
        });
    };
    return react_1.default.createElement("ul", { className: "tree" }, renderItems(items));
};
Tree.propTypes = {
    items: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        id: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]).isRequired,
        type: prop_types_1.default.string.isRequired,
        loading: prop_types_1.default.bool,
    })),
    expanded: prop_types_1.default.object.isRequired,
    renderLabel: prop_types_1.default.func.isRequired,
    searchIds: prop_types_1.default.object,
};
Tree.defaultProps = {
    items: [],
    searchIds: null,
};
exports.default = Tree;
//# sourceMappingURL=Tree.js.map